module.exports = __webpack_public_path__ + "img/longxin01.979342f4.png";